import { render, staticRenderFns } from "./CreditsDepletedAlert.vue?vue&type=template&id=18eba8a2&"
import script from "./CreditsDepletedAlert.vue?vue&type=script&lang=ts&"
export * from "./CreditsDepletedAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports